import { Component, OnInit } from '@angular/core';
import { BottomSheet } from '../bottom.sheet';
import { ApiService } from '../api.service';
import { PdfService } from '../pdf.service';
import { Router } from '@angular/router';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { AuthService } from '../auth.service';
import { HandlerService } from '../handler.service';

@Component({
  selector: 'app-review-invoice',
  templateUrl: './review-invoice.component.html',
  styleUrls: ['./review-invoice.component.scss'],
})
export class ReviewInvoiceComponent {
  discountAmt;
  id;
  data: any = [];
  invoiceObj: any;
  header;
  datename;
  date = new Date();
  country;
  region;
  show:boolean=false;
  recordPay:boolean;
  amountPaid;
  paymentStatus: any = [{ id: 2, name: "Paid" },
  { id: 1, name: "Not Paid" }];;
  paymentMonth:any;
  msg;
  state;
  refNo;
  city;
  url;
  cost;
  pop: boolean;
  dateFormat;
  paymentId;
  paymentName;

  paymentMode: any = [{ id: 1, name: "Cash" },
  { id: 4, name: "Cheque" },{ id: 5, name: "Google Pay" },{id: 7, name: "Phonepe"},{id: 8, name: "Paytm"}];
  payId;
  monthObj: any = [{id:1, name: "January"},
  {id:2, name: "February"},
  {id:3, name:"March"},
  {id:4, name:"April"},
  {id:5,name:"May"},
  {id:6,name:"June"},
  {id:7,name:"July"},
  {id:8,name:"August"},
  {id:9,name:"September"},
  {id:10,name:"October"},
  {id:11,name:"November"},
  {id:12,name:"December"}];
  monthId;
  monthName;
  paymentYear;
  PayCost;
  paymentStatusName;
  paymentStatusId;
  paysts;
  loader:boolean=false;
  packInd;
  pendingAmt;
  adjustedAmt;
  reason;
  
  active: boolean = false;
  max;
min = 1900; 
serviceId;
minDate = new Date();
  constructor(
    private service: ApiService, 
    public pdf: PdfService,
    public router: Router,
    private bottomSheet: MatBottomSheet, 
    public auth: AuthService,
    private handler: HandlerService,
  ) { }
  ionViewWillEnter() {
    // this.max = this.minDate.getFullYear();
    this.url = window.location.href;
    this.monthId = sessionStorage.getItem('month')
    this.serviceId =sessionStorage.getItem('serviceId')
    this.paymentYear = sessionStorage.getItem('year')
    this.paysts = sessionStorage.getItem('status')
    if(this.paysts==1){
      this.recordPay=true;
    }else{
      this.recordPay=false;
    }
    this.pdf.loader=true;
    this.dateFormat = this.auth.getDateformat();

    this.id = this.url.split("/").pop();
    this.service.getInvoiceById(this.id).subscribe((res: any) => {
      this.pdf.loader=false;
      if (res) {
        this.invoiceObj = res;   
        this.PayCost = res.payTotal;
        this.paymentId = res.paymentMode;
        this.paymentStatusId = res.paymentStatus;
        this.amountPaid=res.amountPaid;
        this.refNo=res.referenceId; 
        this.adjustedAmt=res.adjustedPayTotal;
       this.reason=res.adjustedComments;
        this.active= res.adjusted;
        this.pendingAmt=res.balanceAmount;  
        this.paymentMode.map(res=>{        
          if(res.id == this.paymentId ){
            this.paymentName = res.name;
            this.paymentId = res.id;
          }
        })
        this.paymentStatus.map(res=>{
          if(res.id == this.paymentStatusId ){
            this.paymentStatusName = res.name
          }
          
        })                               
        if(res.serviceRequests[0].id){
        this.payId = res.serviceRequests[0].id;
        this.packInd =  res.subscriptionInd
        }else{
          this.payId = this.id;
        }   
      }
    },
      err => {
        this.handler.res(err.error);
        this.pdf.loader=false;
      })
    if (this.url.includes("review-order")) {
      this.header = "INVOICE";
      this.datename = "Due Date";

    }
  
  }
  async routeToPayment(){
    let z:any = await this.service.getPaymentDetails(this.payId).toPromise()
    let y = z.find(res => { return res.paymentMode == 2 });
    if( y && y.accountNbr != " "){
    sessionStorage.setItem('payee',y.accountNbr);
    sessionStorage.setItem('pay', this.PayCost);
    sessionStorage.setItem('serviceId', this.payId);
    this.router.navigate(['/payment/' + this.payId]);
    }
    else{
      this.loader=false;
      this.handler.error('Payment Account Not Mapped. Please contact Org Admin')
    }
  }

  openBottomSheet(): void {
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.paymentMode,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      this.paymentId = res.id;
      this.paymentName = res.name;
      if(this.paymentId==4 || this.paymentId==5){
        this.show=true;
        this.refNo="";
      }else{
        this.show=false;
      }
    });
  }
  recordPayment() {

    this.url = window.location.href;
    var post;
    if(this.url.includes('review-invoice-reqs')){
      post = {
        cost: this.PayCost,
        paymentMode: this.paymentId,
        invoiceNotes:this.msg,
        paymentRcvdBy: localStorage.getItem("currentUserId"),
        referenceId:this.refNo,
        paymentStatus:2, 
        amountPaid:this.amountPaid,
        adjustedPayTotal:this.adjustedAmt,
        adjustedComments:this.reason,
        adjusted:this.active,        
      }
      this.service.postPaymentDetails(this.serviceId,post).subscribe(res => {
        this.handler.res("Payment Details Added SuccessFully");      
        this.pop = false;
        this.PayCost =undefined;       
          this.router.navigate(['/manage-ondemand-req']);        
      },
        err => {
          this.handler.res(err.error);    
          this.pop = false;
        }
      )
    }else{
      post = {
        cost: this.PayCost,
        paymentMode: this.paymentId,
        invoiceNotes:this.msg,
        paymentRcvdBy: localStorage.getItem("currentUserId"),  
        month:this.monthId,
        year:this.paymentYear,
        referenceId:this.refNo,
        paymentStatus:2, 
        amountPaid:this.amountPaid,
        adjustedPayTotal:this.adjustedAmt,
        adjustedComments:this.reason,
        adjusted:this.active,   
      }
      this.service.postSubsPaymentDetails(this.serviceId,post).subscribe(res => {
        this.handler.res("Payment Details Added SuccessFully");
         this.pop = false;
        this.PayCost =undefined;      
          this.router.navigate(['/vendor-subs']);   
       
      },
        err => {
          this.handler.res(err.error);       
          this.pop = false;
        }
      )
    }
  
  }

  recordPayment1() {
    this.url = window.location.href;
    var post;
    if(this.url.includes('review-invoice-reqs')){
      post = {
        cost: this.PayCost,
        paymentMode: this.paymentId,
        invoiceNotes:this.msg,
        paymentRcvdBy: localStorage.getItem("currentUserId"),  
        referenceId:this.refNo,
        paymentStatus:this.paymentStatusId,
        amountPaid:this.amountPaid,
        adjustedPayTotal:this.adjustedAmt,
        adjustedComments:this.reason,
        adjusted:this.active,   
      }
      this.service.postPaymentDetails(this.serviceId,post).subscribe(res => {
        this.handler.res("Payment Details Added SuccessFully");  
        this.pop = false;
        this.PayCost =undefined; 
      
          this.router.navigate(['/manage-ondemand-req']);
   
       
      },
        err => {
          this.handler.res(err.error);
          this.pop = false;
        }
      )
    }else{
      post = {
        cost: this.PayCost,
        paymentMode: this.paymentId,
        invoiceNotes:this.msg,
        paymentRcvdBy: localStorage.getItem("currentUserId"),  
        month:this.monthId,
        year:this.paymentYear,
        referenceId:this.refNo,
        paymentStatus:this.paymentStatusId,
        amountPaid:this.amountPaid,
        adjustedPayTotal:this.adjustedAmt,
        adjustedComments:this.reason,
        adjusted:this.active,   
      }
      this.service.postSubsPaymentDetails(this.serviceId,post).subscribe(res => {
        this.handler.res("Payment Details Added SuccessFully"); 
        this.pop = false;
        this.PayCost =undefined;      
          this.router.navigate(['/vendor-subs']);   
       
      },
        err => {
          this.handler.res(err.error);          
          this.pop = false;
        }
      )
    }
  
  }

returnYear(date){
  var x = date.split("T");
  var y = x[0].split("-");
  return y[0]
}

  invoiceSave() {
    var post = {
      cost: this.PayCost,
      paymentMode: this.paymentId,
      invoiceNotes:this.msg,
      paymentRcvdBy: localStorage.getItem("currentUserId")
    }
      this.service.postPaymentForInvoice(this.id,post).subscribe(res => {
      this.handler.res("Payment Details Added SuccessFully");
      this.pop = false;
      this.PayCost =undefined;
      this.router.navigate(['/admin-invoice']);
    },
      err => {
        this.handler.res(err.error);     
        this.pop = false;
      }
    )
  }
  

//   completePayment(id,price){
//     var post = {
//     cost:price,
//     paymentMode:2,
//     paymentRcvdBy: localStorage.getItem("currentUserId")
//   }
//  this.service.postPaymentForPurchaseAdd(id,post).subscribe(res=>{
//    this.handler.res('Ad Service Purchased SuccessFully');
//    sessionStorage.clear();
//  },err=>{
//    this.loader=false;
//    this.handler.err(err)
//  })
// }

  
  applyDiscount(){
    this.pdf.loader = true;
    let post = { applyDiscount : this.discountAmt }
    this.service.applyDiscountRequest(this.payId, this.discountAmt,this.packInd,post).subscribe(res => {
      this.ionViewWillEnter();
      this.discountAmt = undefined;
    },
      err => {
        this.pdf.loader = false;
        this.handler.err(err)
      })

  }

  openBottomSheetStatus(){
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.paymentStatus,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      this.paymentStatusId = res.id;
      this.paymentStatusName = res.name;
      if(this.paymentStatusId==1){
        this.amountPaid="";
        this.refNo="";
        this.paymentId="";
        this.paymentName="";
      }else{
        this.paymentId = this.invoiceObj.paymentMode;
        this.paymentStatusId = this.invoiceObj.paymentStatus;
        this.amountPaid=this.invoiceObj.amountPaid;
        this.refNo=this.invoiceObj.referenceId;
        this.paymentMode.map(res=>{
          if(res.id == this.paymentId ){
            this.paymentName = res.name
          }
        })
        this.paymentStatus.map(res=>{
          if(res.id == this.paymentStatusId ){
            this.paymentStatusName = res.name
          }
        })
      }
    });
  }

  ionViewWillLeave(){
    sessionStorage.clear();
  }
  

}

